module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "contents"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "imagel"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "height": "1",
      "src": "images/line.jpg",
      "width": "256"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/intro#intro"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part01#part01"
    }
  }, [_c('strong', [_vm._v("Part 1 A New Metapsychology of the Unconscious")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "none"
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01"
    }
  }, [_c('em', [_vm._v("Chapter 1    Attachment Trauma, Transference, and Countertransference")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "none"
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02"
    }
  }, [_c('em', [_vm._v("Chapter 2    Unconscious Anxiety and Defenses")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "none"
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03"
    }
  }, [_c('em', [_vm._v("Chapter 3    Spectra of Suitable Patients")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "none"
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch04"
    }
  }, [_c('em', [_vm._v("Chapter 4    Complex Transference Feelings and the Unconscious Therapeutic Alliance")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "none"
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05#ch05"
    }
  }, [_c('em', [_vm._v("Chapter 5    Somatic Experience of Emotions")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part02#part02"
    }
  }, [_c('strong', [_vm._v("Part 2    Clinical Application")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "none"
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch06#ch06"
    }
  }, [_c('em', [_vm._v("Chapter 6    Initiating Treatment")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "none"
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter 7    Why No Signals?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "none"
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter 8    Low versus Mid versus High Rise in the Transference")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "none"
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter 9    Pressure: Reaching through Resistance")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "none"
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter 10  Clarification and Challenge")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "none"
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter 11  Head-On Collision")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "none"
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter 12  The Low Resistance Patient: The Open Door")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "none"
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter 13  The Moderately Resistant Patient: The Guarded Cellar")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "none"
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter 14  The Highly Resistant Patient: The Fortified Castle")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "none"
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter 15  High Resistance with Repression: The Paralyzed Prisoner")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "none"
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter 16  Fragile Character Structure: Terror in the Dungeon")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapb"
  }, [_c('span', {
    staticClass: "none"
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter 17  Severe Fragile Character Structure: Fractured and Frightened")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "none"
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/appendix#appendix",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix    Empirical Basis of Short-Term Psychodynamic Psychotherapy and Intensive Short-Term Dynamic Psychotherapy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/recommendedreading#recommendedreading",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Recommended Reading")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/bib#bib",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/index#index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/abouttheauthor#abouttheauthor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")]), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 69
// module chunks = 0